/// <amd-module name="Artifacts/Root/FuncTools" />
/**
 * FuncTools module provides useful functions that can be used to extend or change behavior of existing functions and methods.
 */

/**
 * delay execution of function on a provied period and get result of function execution as a Promise object.
 *
 * @param func Function that needs to be delayed.
 * @param wait Delay time in milliseconds (Function may execute later than wait time passed, but not earlier).
 * @param args Arguments to the function.
 * @returns Returns Promise that resolves value returned by the function.
 */
export async function delay<FuncT extends (...args: any[]) => any>(
  func: FuncT,
  wait: number,
  args: Parameters<FuncT>,
): Promise<ReturnType<FuncT>> {
  return new Promise<ReturnType<FuncT>>((resolve, reject) => {
    setTimeout(() => {
      try {
        resolve(func(...args));
      } catch (error) {
        reject(error);
      }
    }, wait);
  });
}
